import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
    selector: 'app-check-transaction-code-reject',
    templateUrl: './checkTransactionRejectWindow.component.html'
})

export class CheckTransactionRejectWindowComponent implements OnInit, OnDestroy {
    form: FormGroup;
    constructor(private formBuilder: FormBuilder, private modal: NgbActiveModal) {
        this.form = this.formBuilder.group({
            rejectReason: ['', Validators.required]
        });
    }

    ngOnInit(): void {

    }

    ngOnDestroy(): void {}

    /**
     * Сохранить
     */
    save(){
        this.modal.close(this.form.get('rejectReason').value);
    }

    /**
     * Закрываем модальное окно
     */
    goBack() {
        this.modal.dismiss(false);
    }
}
